// Hook listy metod dostawy klienta handlowca – GET /sales-crm/clients/:cid/delivery-methods

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface ISalesCrmDeliveryMethodOption {
  id: number;
  delivery_method_id: number;
  delivery_method: string | null;
  is_active?: boolean;
}

export interface ISalesCrmDeliveryMethodsResponse {
  items: ISalesCrmDeliveryMethodOption[];
}

const getSalesCrmClientDeliveryMethods = (
  clientId: number
): Promise<ISalesCrmDeliveryMethodsResponse> =>
  axios.get(`/sales-crm/clients/${clientId}/delivery-methods`);

export const useGetSalesCrmClientDeliveryMethods = (
  clientId: number,
  options?: UseQueryOptions<ISalesCrmDeliveryMethodsResponse, IError>
) =>
  useQuery<ISalesCrmDeliveryMethodsResponse, IError>(
    ['sales-crm', 'client', clientId, 'delivery-methods'],
    () => getSalesCrmClientDeliveryMethods(clientId),
    {
      ...options,
      enabled: options?.enabled !== false && clientId > 0
    }
  );
